<template>
  <v-container fluid>
    <v-layout align-top justify-center>
      <v-flex xs12 sm10 md10 lg10>
        <v-sheet color="white" elevation="0" class="pa-2">
          <!-- Vista de escritorio para pantallas md y mayores -->
          <v-card class="d-none d-md-block">
            <v-card-title>
              <v-row align="center">
                <v-col cols="6">
                  <span>Facturas</span>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="issueDate"
                    label="Fecha"
                    hide-details="auto"
                    required
                    dense
                    outlined
                    type="date"
                    @input="get_notes"
                    class="float-right"
                    style="max-width: 180px"
                  />
                </v-col>
              </v-row>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="credit_notes"
              :items-per-page="10"
              item-key="id"
              sort-by="name"
              class="elevation-0"
              :loading="loading_status"
              loader-height="10"
              loading-text="Cargando ..."
              @click:row="get_e_doc"
              :class="{ 'cursor-pointer': !loading_status }"
            >
              <template v-slot:[`item.cufe`]="{ item }">
                <v-icon small class="mr-2" v-if="item.cufe"> mdi-check-all </v-icon>
              </template>
              <template v-slot:[`item.dian_id`]="{ item }">
                <v-icon small class="mr-2" v-if="item.dian_id"> mdi-check-all </v-icon>
              </template>
              <template v-slot:[`item.cufe_n`]="{ item }">
                <v-icon small class="mr-2" v-if="item.cufe_n"> mdi-check-all </v-icon>
              </template>
            </v-data-table>
          </v-card>

          <!-- Vista móvil solo para xs y sm -->
          <v-card class="d-md-none">
            <v-card-title>
              <span>Facturas</span>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="issueDate"
                label="Fecha"
                hide-details="auto"
                required
                dense
                outlined
                type="date"
                @input="get_notes"
                style="max-width: 160px"
              />
            </v-card-title>

            <v-list two-line>
              <v-list-item-group>
                <template v-for="(item, index) in credit_notes">
                  <v-list-item
                    :key="item.id"
                    @click="get_e_doc(item)"
                    class="cursor-pointer"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        {{ item.doc_number }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <span>{{ formatDate(item.issuedate) }}</span>
                        <span class="ml-2">{{ item.invoice }}</span>
                      </v-list-item-subtitle>

                      <div class="d-flex align-center mt-1">
                        <div v-if="item.cufe" class="mr-3">
                          <v-icon color="success" x-small>mdi-check-all</v-icon>
                          <span class="caption ml-1">CUFE</span>
                        </div>
                        <div v-if="item.cufe_n">
                          <v-icon color="success" x-small>mdi-check-all</v-icon>
                          <span class="caption ml-1">NC</span>
                        </div>
                      </div>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="font-weight-bold">{{
                        formatCurrency(item.doc_value)
                      }}</span>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="index < credit_notes.length - 1"
                    :key="'div-' + index"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>

            <!-- Estados de la lista: cargando y vacío -->
            <div v-if="loading_status" class="text-center my-4">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <div class="mt-2">Cargando...</div>
            </div>

            <div
              v-if="!loading_status && credit_notes.length === 0"
              class="text-center my-4 pa-4"
            >
              <v-icon large color="grey lighten-1">mdi-file-document-outline</v-icon>
              <div class="grey--text">No hay facturas disponibles para esta fecha</div>
            </div>
          </v-card>
        </v-sheet>
      </v-flex>
    </v-layout>
    <noteViewer
      :item="item"
      :dialog="dialog"
      @close="dialog = false"
      @refresh="refresh()"
    />
  </v-container>
</template>

<script>
import { webserver, getToday } from "../services/webserver.js";
import noteViewer from "../components/doc_viewer.vue";

export default {
  components: { noteViewer },
  data() {
    return {
      errors: [],
      valid: false,
      loading_status: false,
      f_required: [(v) => !!v || "Requerido"],
      f_email: [
        (v) => !!v || "Correo valido",
        (v) => /.+@.+/.test(v) || "Correo no valido",
      ],
      imageUrl: null,
      dialog: false,
      headers: [
        {
          text: "Fecha",
          align: "start",
          sortable: true,
          value: "issuedate",
          dataType: "text",
        },
        {
          text: "Documento",
          align: "start",
          sortable: true,
          value: "doc_number",
          dataType: "text",
        },
        {
          text: "Factura",
          align: "start",
          sortable: true,
          value: "invoice",
          dataType: "text",
        },
        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "doc_value",
          dataType: "number",
        },
        {
          text: "CUFE",
          align: "end",
          sortable: true,
          value: "cufe",
          dataType: "number",
        },
        {
          text: "NC",
          align: "end",
          sortable: true,
          value: "cufe_n",
          dataType: "number",
        },
      ],
      credit_notes: [],
      item: { document: null, items: [], payments: [] },
      issueDate: getToday(),
    };
  },
  mounted() {
    this.get_notes();
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";
      // Extraer solo la fecha sin la hora
      return dateString.split(" ")[0];
    },
    formatCurrency(value) {
      if (!value) return "0";
      // Formatear como moneda
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
      }).format(value);
    },
    refresh() {
      this.get_notes();
    },
    get_notes() {
      this.loading_status = true;
      var qry = {
        store: window.store.store_id,
        table: "docs",
      };
      qry.filters = [
        {
          field: "doc_type",
          operator: "=",
          value: "Invoice",
        },
        {
          field: "DATE(issuedate)",
          operator: "=",
          value: this.issueDate,
        },
        {
          field: "store",
          operator: "=",
          value: window.store.store_id,
        },
      ];
      if (this.$store.getters.profile.user_access == "USUARIO") {
        qry.filters.push({
          field: "userId",
          operator: "=",
          value: this.$store.state.profile.email,
        });
      }
      console.log(qry);
      webserver("get_dataTable", qry, (data) => {
        console.log(data);
        this.loading_status = false;
        this.credit_notes = data;
      });
    },
    get_e_doc(e) {
      var issudate = e.issuedate.split(" ");
      console.log(issudate[0]);
      var doc = {
        store: e.store,
        issueDate: issudate[0],
        did: e.doc_number,
      };
      console.log(doc);
      webserver("get_invoice_fe", doc, (data) => {
        console.log(data);
        this.item = data;
        this.dialog = true;
        // data.doc.doc_type = "Invoice";
        this.loading_vendors = false;
      });
    },
  },
};
</script>

<style>
/* Estilos adicionales para mejorar la apariencia */
.v-list-item__subtitle {
  margin-top: 4px;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer:hover {
  background-color: rgba(0, 0, 0, 0.03);
}
</style>
